import React from 'react';

import Skeleton from '@material-ui/lab/Skeleton';

import { TabularGrid, PaddedGrid } from './styles';

const QuestionsListHeader = () => (
  <>
    {[...Array(4)].map((i) => (
      <TabularGrid container>
        <PaddedGrid item xs={6}>
          <Skeleton height="30px" width="60%" />
        </PaddedGrid>
        <PaddedGrid item xs={2}>
          <Skeleton height="30px" width="60%" />
        </PaddedGrid>
        <PaddedGrid item xs={3}>
          <Skeleton height="30px" width="60%" />
        </PaddedGrid>
      </TabularGrid>
    ))}
  </>
);

export default QuestionsListHeader;
